import Vue from 'vue';
import Veutify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VeeValidate from 'vee-validate';
import App from './App.vue';
import vSelect from 'vue-select';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
import router from './router';
import store from './store';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueRippler from 'vue-rippler';
import IdleVue from 'idle-vue';

// Adding lodash
// Can be used with $_
import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });
Vue.use(VueRippler);
Vue.use(CKEditor);
Vue.use(VeeValidate, {
    events: 'blur',
    delay: 0
});

// Dispatch initial actions on App Start
store.dispatch('auth/loadFromLocalStorage');
// store.dispatch('onboard/legal_entities/loadFromLocalStorage');

Vue.use(Veutify);
// Vue.use(VueCroppie);
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component('vue-cropper', VueCropper);
export const eventBus = new Vue();
Vue.use(IdleVue, {
    eventEmitter: eventBus,
    events: ['mousemove', 'load', 'scroll', 'keydown', 'mousedown', 'touchstart'],
    idleTime: 600000,
    keepTracking: true,
    store
});

Vue.config.productionTip = false;

import BottomActionContainer from '@/components/Button/BottomActionContainer';
import PopupBottomContainer from '@/components/Button/PopupBottomContainer';
import BtnGrp from '@/components/Button/ButtonGroup.vue';
import FormAddButton from '@/components/AddButtonInForm.vue';
import Btn from '@/components/Button/Button.vue';
import PopupBtn from '@/components/Button/PopupButton.vue';
import BtnSkip from '@/components/Button/SkipButton.vue';
import UploadButton from '@/components/Button/uploadButton.vue';
import DownloadButton from '@/components/Button/downloadButton.vue';
import TlHeader from '@/components/headers/TlHeader.vue';
import Txt from '@/components/Input/TextField.vue';
import SearchDropdown from '@/components/Input/SearchDropdown.vue';
import TlCheckbox from '@/components/Input/CheckBox.vue';
import TlRadio from '@/components/Input/Radio.vue';
import TlSelect from '@/components/Input/Select.vue';
import DataTable from '@/components/DataTable.vue';
// import AddEmployeeManually from '@/components/AddEmployeeManually.vue';
import EmployeeDetailsCard from '@/components/EmployeeDetailsCard.vue';
import Tabs from '@/components/tabs/index.vue';
import Tab from '@/components/tabs/tab.vue';
import ToastMessage from '@/components/ToastMessage.vue';
import PopUpMessage from '@/components/PopUpMessage.vue';
import DatePicker from '@/components/DatePicker.vue';
import TlLoading from '@/components/TlLoading.vue';
import SearchField from '@/components/SearchField.vue';
import UploadFile from '@/components/Upload.vue';
import UploadImage from '@/components/UploadImage.vue';
import UploadFileNew from '@/components/UploadFile.vue';
import Accordion from '@/components/Accordion.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';
import TlSearchComponent from '@/components/TlSearchDropdown.vue';
import ScrollIcon from '@/components/ScrollIcon.vue';
import PopUpWindow from '@/components/PopUpWindow.vue';
import PageUnderDevelopment from '@/components/PageUnderDevelopment.vue';


import shimmer from '@/components/shimmer.vue';
import EmpFilter from '@/components/EmpFilter.vue';
import HourGlassAnimation from '@/assets/animations/lottie/HourGlass';
import TickAnimation from '@/assets/animations/lottie/Tick';
import LoadingAnimation from '@/assets/animations/lottie/Loading';
import dwsLoadingAnimation from '@/assets/animations/lottie/DwsLoading';


// Added new componentfor popup window large
import PopUpWindowLarge from '@/components/PopUpWindowLarge.vue';

import VueApexCharts from 'vue-apexcharts'
import AccessDenied from '@/components/access-denied.vue'
import dataTableLogSheet from '@/modules/dashboard/views/pages/logSheet/dataTableLogSheet.vue'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// Global Component Registrations
Vue.component('bottom-action-container', BottomActionContainer);
Vue.component('popup-bottom-container', PopupBottomContainer);
Vue.component('btn-grp', BtnGrp);
Vue.component('btn', Btn);
Vue.component('popup-btn', PopupBtn);
Vue.component('btn-skip', BtnSkip);
Vue.component('upload-button', UploadButton);
Vue.component('download-button', DownloadButton);
Vue.component('tl-btn', Btn);
Vue.component('tl-btn-grp', BtnGrp);
Vue.component('tl-btn-skip', BtnSkip);
Vue.component('tl-checkbox', TlCheckbox);
Vue.component('tl-radio', TlRadio);
Vue.component('tl-header', TlHeader);
Vue.component('tl-select', TlSelect);
Vue.component('tl-tabs', Tabs);
Vue.component('tl-tab', Tab);
Vue.component('tl-txt', Txt);
Vue.component('tl-search', SearchField);
Vue.component('tl-accordion', Accordion);
Vue.component('tl-search-dropdown', SearchDropdown);
Vue.component('emp-filter', EmpFilter);
Vue.component('txt', Txt);
Vue.component('data-table', DataTable);
Vue.component('employee-details-card', EmployeeDetailsCard);
Vue.component('toast-message', ToastMessage);
Vue.component('pop-up-message', PopUpMessage);
Vue.component('pop-up-window', PopUpWindow);
Vue.component('date-picker', DatePicker);
Vue.component('form-add-button', FormAddButton);
Vue.component('tl-loading', TlLoading);
Vue.component('breadcrumb', BreadCrumb);
Vue.component('under-construction', PageUnderDevelopment);
Vue.component('shimmer', shimmer);
// vue searchcomponent
Vue.component('search-dropdown', TlSearchComponent);
Vue.component('v-select', vSelect);
// vue upload component
Vue.component('upload', UploadFile);
/*
Author: Vaishnavi
Date: 21/11/2019
Issue: Upload Image Component
 */
Vue.component('upload-image', UploadImage);
Vue.component('access-denied', AccessDenied);
// dataTable for logSheet
Vue.component('data-table-log-sheet', dataTableLogSheet)

// Animations
Vue.component('hour-glass-animation', HourGlassAnimation);
Vue.component('tick-animation', TickAnimation);
Vue.component('loading-animation', LoadingAnimation);
Vue.component('dws-paylief-loading', dwsLoadingAnimation);
/*
Author: Vaishnavi
Date: 22/11/2019
Issue: Upload File Component
 */
Vue.component('upload-file', UploadFileNew);
Vue.component('scroll-icon', ScrollIcon);
Vue.directive('maxchars');
Vue.directive('alpha-num');
Vue.directive('numeric-only');
Vue.directive('float-only');
Vue.directive('uppercase');
new Vue({
    data: {
        isSaving: false
    },
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');

// to restrict an input field to a particular length
// Usage: v-maxchars="6"
Vue.directive('maxchars', {
    bind(el, dataLength) {
        el.addEventListener('keydown', (e) => {
            if (String(e.target.value).length == dataLength.value) {
                // To allow back(8), delete(46), left-arrow(37), right-arrow(39) and tab(9) keys
                if (!(e.which == 8 || e.which == 9 || e.which == 37 || e.which == 39 || e.which == 46)) {
                    e.preventDefault();
                }
            }
        });
    }
});

// to restrict only to alphabets and numbers
// Usage: v-alpha-num
Vue.directive('alpha-num', {
    bind(el) {
        el.addEventListener('keydown', (e) => {
            if (
                [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && e.ctrlKey === true) ||
                // Allow: Ctrl+C
                (e.keyCode === 67 && e.ctrlKey === true) ||
                // Allow: Ctrl+X
                (e.keyCode === 88 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 65 && e.keyCode <= 90)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    }
});

// to restrict only to nnumbers (does not allow -,+,.,e)
// Usage: v-numeric-only
/*
Author: Vinod
Date: 05/03/2020
Issue Desc: Minimum Experience(In Months) field accepting alphabets.
Search_string: PL_2854
 */

Vue.directive('numeric-only', {
    bind(el) {
        el.addEventListener('keypress', (e) => {
            //  Start PL_2854
            e = e ? e : window.event;
            var charCode = e.which ? e.which : e.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                e.preventDefault();
            }
            // End PL_2854
        });
    }
});

Vue.directive('float-only', {
    bind(el) {
        el.addEventListener('keypress', (e) => {
            //  Start PL_2854
            e = e ? e : window.event;
            var charCode = e.which ? e.which : e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)) {
                e.preventDefault();
            }
            // End PL_2854
        });
    }
});

Vue.directive('uppercase', {
    bind(el) {
        el.addEventListener('keyup', (e) => {
            e.target.value = e.target.value.toUpperCase();
        });
    }
});


Vue.component('pop-up-window-lg', PopUpWindowLarge);
